import React, { Component } from 'react';

import SamplingVisualizer from './SamplingVisualizer';
import { MODAL_SAMPLING_VISUALIZER } from '../constants';
import { withModalContext } from '../../../contexts/ModalContext';

class SamplingVizWrapper extends Component {
  closeModal = () => {
    this.props.modalContext.closeModal(MODAL_SAMPLING_VISUALIZER);
  };

  render() {
    let modalProps =
      this.props.modalContext.openModalProps[MODAL_SAMPLING_VISUALIZER];
    let id = (modalProps && modalProps.id) || null;
    let name = (modalProps && modalProps.name) || null;
    let modalOpen = this.props.modalContext.isModalOpen(
      MODAL_SAMPLING_VISUALIZER
    );
    return (
      <SamplingVisualizer
        modalOpen={modalOpen}
        onClose={this.closeModal}
        id={id}
        name={name}
      />
    );
  }
}

export default withModalContext(SamplingVizWrapper);
